import React from 'react';
import logo from '../images/inspector-dottie-welcome.png';

function Loading() {
	return (
		<div className="Welcome">
			<section>
				<img src={logo} className="Dottie" alt="Dottie" />
			</section>
		</div>
	);
}

export default Loading;